import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { getPosters } from '../../Store/posters/postersSlice';
import styles from '../../styles/HomePage.module.scss';
import '../../styles/slick.scss';
import '../../styles/slick-theme.scss';
import BG from '../../images/shlifmashina.png';
import { posterUrl } from '../../utils/imageUrl';
import CarouselNav from '../common/CarouselNav';

const PosterSlide = ({ poster, onButtonClick }) => {
  const title = poster.title;
  const subtitle = poster.subtitle;
  const heading = poster.heading;
  const buttonText = poster.buttonText;
  const imageUrl = (poster.image && typeof poster.image === 'string')
    ? posterUrl(poster.image)
    : BG;

  return (
    <div className={styles.home}>
      <div className={styles.title}>{title}</div>
      <div className={styles.product}>
        <div className={styles.text}>
          <div className={styles.subtitle}>{subtitle}</div>
          <h1 className={styles.head}>{heading}</h1>
          <button
            type="button"
            className={styles.button}
            onClick={() => onButtonClick(poster)}
          >
            {buttonText}
          </button>
        </div>
        <div className={styles.image}>
          <img src={imageUrl} alt={heading || 'Постер'} />
        </div>
      </div>
    </div>
  );
};

const Poster = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const { list: posters } = useSelector((state) => state.posters);

  useEffect(() => {
    dispatch(getPosters());
  }, [dispatch]);

  const handleButtonClick = (poster) => {
    if (poster.productId) {
      navigate(`/products/${poster.productId}`);
    } else {
      navigate(poster.buttonLink || '/');
    }
  };

  if (!posters || posters.length === 0) {
    return (
      <section className={styles.posterCarousel}>
        <PosterSlide
          poster={{
            title: 'Велика знижка 20%',
            subtitle: 'Розпродаж',
            heading: 'Стрічкова шліфувальна машина APRO SB1100',
            buttonText: 'Купити зараз',
            image: null,
            productId: null,
            buttonLink: '/',
          }}
          onButtonClick={() => navigate('/')}
        />
      </section>
    );
  }

  if (posters.length === 1) {
    return (
      <section className={styles.posterCarousel}>
        <PosterSlide poster={posters[0]} onButtonClick={handleButtonClick} />
      </section>
    );
  }

  const posterNav = (
    <CarouselNav
      total={posters.length}
      current={slideIndex}
      onPrev={() => sliderRef.current?.slickPrev()}
      onNext={() => sliderRef.current?.slickNext()}
      onDotClick={(index) => sliderRef.current?.slickGoTo(index)}
    />
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    arrows: false,
    pauseOnHover: true,
    beforeChange: (_current, next) => setSlideIndex(next),
  };

  return (
    <section className={styles.posterCarousel}>
      <Slider ref={sliderRef} {...settings}>
        {posters.map((poster) => (
          <div key={poster.id} className={styles.slide}>
            <PosterSlide poster={poster} onButtonClick={handleButtonClick} />
          </div>
        ))}
      </Slider>
      {posterNav}
    </section>
  );
};

export default Poster;
